var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{attrs:{"min-height":"80vh"}},[_c('router-view',{attrs:{"pr-items":_vm.prItems},on:{"convert-to-pr":_vm.convertToPR}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }